<div class="page-title-area item-bg-6">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Artificial Intelligence Tools</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Artificial Intelligence Tools</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-video">
            <div class="details-image">
                <!-- Puedes agregar una imagen principal aquí si deseas -->
            </div>
            <div class="details-video">
                
            </div>
            <div class="text">
                <h3>Creative Work Fueled by AI Tools</h3>
                <p>
                    I use artificial intelligence tools to enhance every stage of my creative process. From content generation to automation and visual production, AI helps me work smarter and bring ideas to life:
                    <br><br>
                    • <strong>ChatGPT:</strong> I rely on ChatGPT for ideation, writing, scripting, and technical problem-solving.<br>
                    • <strong>Kling AI:</strong> I create realistic AI-generated videos and visual scenes for storytelling.<br>
                    • <strong>Image Generation Tools:</strong> I use platforms like Leonardo AI and Midjourney to turn concepts into compelling images.<br>
                    • <strong>Automation with AI:</strong> I connect tools through Make.com and Zapier to automate repetitive tasks.<br>
                    • <strong>AI Media Assistants:</strong> I enhance videos, audios, and subtitles using artificial intelligence tools for editing and optimization.
                </p>
            </div>
        </div>
        <div class="bar"></div>

        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-desc">
                        <h3>Innovation Through Artificial Intelligence</h3>
                        <p>
                            I use artificial intelligence tools not just to accelerate work, but to unlock new creative possibilities. AI is a core part of how I produce, refine, and deliver content:
                            <br><br>
                            <strong>My AI toolset includes:</strong><br>
                            • ChatGPT for content and automation prompts<br>
                            • Kling AI for video scene generation<br>
                            • Midjourney and Leonardo AI for image creation<br>
                            • Make.com for intelligent workflow automation<br>
                            • AI-based platforms for subtitles, dubbing, and voiceovers
                        </p>
                        <div class="features-text">
                            <h4>Why Work With Me?</h4>
                            <p>
                                • <strong>AI-Powered Workflow:</strong> I integrate artificial intelligence tools in every step of the creative process.<br>
                                • <strong>Real Results:</strong> I use AI to generate content quickly, creatively, and with high impact.<br>
                                • <strong>Up-to-Date Skills:</strong> I stay current with the latest AI technologies and trends.<br>
                                • <strong>Hands-On Experience:</strong> I apply these tools daily in real projects, not just in theory.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="https://iartificial.blog/wp-content/uploads/2024/05/descubre-las-mejores-plataformas-de-inteligencia-artificial-gratis-en-linea.jpg.webp" alt="AI Tools Image">
                    </div>
                </div>
            </div>
        </div>

        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="https://t21.com.mx/wp-content/uploads/2024/07/Inteligencia-artificial.jpg" alt="AI Creativity Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>